export const theme = {
    main: '#2867BC',
    white: '#FFFFFF',
    front_end: '#2867BC',
    ui_ux: '#cae4db',
    language: '#008891',
    backend: '#ffb26b',
}